export default {"src":"/_next/static/media/logged_in_user.916f1ac5.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};